import { ThemePalette } from '../Button.types';

export const textLink = ({ text }: Pick<ThemePalette, 'text'>): string => `
  background-color: transparent;
  border: none;
  color: ${text.link};

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;
